import { render, staticRenderFns } from "./real-name.vue?vue&type=template&id=6c789800&scoped=true&"
import script from "./real-name.vue?vue&type=script&lang=js&"
export * from "./real-name.vue?vue&type=script&lang=js&"
import style0 from "./real-name.vue?vue&type=style&index=0&id=6c789800&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c789800",
  null
  
)

export default component.exports